export interface FlipPositionResult {
  vertical: 'below' | 'above';
  horizontal: 'left' | 'right';
}

export function computeFlipPosition(
  triggerRect: Pick<DOMRect, 'top' | 'bottom' | 'left' | 'right'>,
  panelSize: { width: number; height: number },
  viewport: { width: number; height: number },
  preferredHorizontal: 'left' | 'right' = 'left',
  margin = 8
): FlipPositionResult {
  const spaceBelow = viewport.height - triggerRect.bottom - margin;
  const spaceAbove = triggerRect.top - margin;
  const vertical: FlipPositionResult['vertical'] =
    spaceBelow >= panelSize.height || spaceBelow >= spaceAbove ? 'below' : 'above';

  const spaceRightOfLeftEdge = viewport.width - triggerRect.left - margin;
  const spaceLeftOfRightEdge = triggerRect.right - margin;
  const fitsLeftAligned = spaceRightOfLeftEdge >= panelSize.width;
  const fitsRightAligned = spaceLeftOfRightEdge >= panelSize.width;

  let horizontal: FlipPositionResult['horizontal'] = preferredHorizontal;
  if (preferredHorizontal === 'left' && !fitsLeftAligned && fitsRightAligned) {
    horizontal = 'right';
  } else if (preferredHorizontal === 'right' && !fitsRightAligned && fitsLeftAligned) {
    horizontal = 'left';
  }

  return { vertical, horizontal };
}
